module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/shuttle-0efdb8b8bde34ee6c02030370c434d5b.svg&quot;;"